import { BookingServiceV2 } from 'core/api/services/bookingV2';
import { createContext, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const BookingV2Context = createContext(null);

export const BookingProviderV2 = ({ children }) => {
    const [submitting, setSubmitting] = useState(false);
    const { t: translate } = useTranslation();

    const addBooking = async ({ items = [], triper, contractId, paymentPlatformId, isPendingTour, overrideAvailability, hostAgent, additional }) => {
        try {
            setSubmitting(true);
            const result = await BookingServiceV2.reserve({ items, triper, contractId, paymentPlatformId, isPendingTour, overrideAvailability, hostAgent, additional });

            return result;
        } catch (error) {
            toast.error(translate('global_bookings.errors.add_booking'), {
                position: 'top-right',
                theme: 'colored',
            });
            console.error(error);
            return false;
        } finally {
            setSubmitting(false);
        }
    };

    return <BookingV2Context.Provider value={{ submitting, addBooking }}>{children}</BookingV2Context.Provider>;
};

BookingProviderV2.displayName = 'BookingProviderV2';

export const useBookingsV2 = () => useContext(BookingV2Context);
